import { render } from "./KalkulatorComponent.vue?vue&type=template&id=52dc890f"
import script from "./KalkulatorComponent.vue?vue&type=script&lang=js"
export * from "./KalkulatorComponent.vue?vue&type=script&lang=js"

import "./KalkulatorComponent.vue?vue&type=style&index=0&id=52dc890f&lang=css"

import exportComponent from "/builds/christinandrea/kel1-kedaireka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__